




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop, PropSync, Watch } from 'vue-property-decorator'
import CountDownStore from '@/modules/common/coutn-down/store/countDown.store'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: { BaseButton }
})
export default class TimerCountDown extends Vue {
  constructor(
    private readonly countDownStore: CountDownStore
  ) {
    super()
  }

  @Prop({ default: 120 }) seconds!: number
  @PropSync('loading', { default: false }) loadingValue !: boolean

  mounted() {
    if (!this.countDownStore.interval) {
      this.countDownStore.setTimer()
    }
  }

  @Watch('countDownStore.expired')
  onExpired(newVal) {
    this.$emit('expired', newVal)
  }

  @Emit()
  timeOut() {
    clearInterval(this.countDownStore.interval)
  }
}
